import React, { useMemo } from 'react'

import { cardFlags } from 'constants/card-flags'
import { useFlags } from 'components/ff4j'

import * as product from '../constants/product-types'

// bankName = AL | BB | BR
const productsForBank = [product.CHRISTMAS, product.CULTURE]
const productsNotForBank = [product.TUDO, product.POD]

const useValidateProductsFlags = (products = [], bankName = '') => {
    const productsFlags = useMemo(() => {
        const productsWithFlag = products.filter((p) => {
            return !!cardFlags[p.code]
        })

        if (bankName === 'AL')
            return productsWithFlag.map((p) => cardFlags[p.code])

        return productsWithFlag
            .filter((p) => productsForBank.includes(parseInt(p.code)))
            .map((p) => cardFlags[p.code])
    }, [products, bankName])

    const enables = useFlags(productsFlags)

    const productsEnabled = useMemo(() => {
        if (bankName === 'AL')
            return products.filter((p) => {
                if (cardFlags[p.code]) return enables[cardFlags[p.code]]
                return true
            })

        return products.filter((p) => {
            if (productsForBank.includes(parseInt(p.code)))
                return enables[cardFlags[p.code]]

            return !productsNotForBank.includes(parseInt(p.code))
        })
    }, [bankName, enables, products])

    return productsEnabled
}

export default useValidateProductsFlags
